export default {
  map: function(n, start1, stop1, start2, stop2) {
    return ((n-start1)/(stop1-start1))*(stop2-start2)+start2;
  },
  constrain: function(n, low, high) {
    return Math.max(Math.min(n, high), low);
  },
  mapConstrain: function(n, low, high, start, stop) {
    return this.map(this.constrain(n, low, high), low, high, start, stop);
  },
  translateEmg: function(data) {
    let sum = data.reduce(function(a, b) {
      return a + Math.abs(b);
    });
    let avg = sum / data.length;    
    let scale = this.mapConstrain(avg, 0, 50, 0, 1);

    return {
      scaleX: scale,
      scaleY: scale,
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/utils.js
 **/